import moment from "moment";

export function isOrientDate(data: string) {
  const date = moment(data, ["YYYY-MM-DD", "YYYY-MM-DD hh:mm:ss"]);
  return date.isValid();
}

export function asOrientDate(data: string) {
  const date = moment(data, ["YYYY-MM-DD", "YYYY-MM-DD hh:mm:ss"]);
  return date.toDate();
}
